import { render, staticRenderFns } from "./representatives.vue?vue&type=template&id=1f528d2c&scoped=true&"
import script from "./representatives.vue?vue&type=script&lang=js&"
export * from "./representatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f528d2c",
  null
  
)

export default component.exports